import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { Link } from 'react-router-dom';
import { withRouter } from '../../../util/withRouter';
import { Button } from 'react-bootstrap';

import { handleError, forgotPassword } from '../AuthActions';

import logo from './img/logo-nave-icon.svg';

// Import Style
import '../Auth.scss';

class ForgotPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      completed: false,
    };
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.email) {
      this.props.setError({
        data: {
          email: {
            msg: 'error.email.empty',
          },
        },
      });
      return false;
    }

    this.props
      .forgotPassword({
        email: this.state.email,
      })
      .then(
        () => {
          this.setState({ completed: true });
        },
        (err) => {}
      );
  };

  render() {
    return (
      <div className='login_bg'>
        <Helmet>
          <title>{pageTitle('Forgot password')}</title>
          <link rel="alternate" href={`https://${this.props.app}.getnave.com`} hrefLang="en-us" />
        </Helmet>
        <div className={`login_form single_form ${this.props.app}`}>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            {!this.state.completed ? (
              <div className='left_part'>
                <h1>Forgot your password?</h1>
                <p className="mb-4">
                  Enter your email and we’ll send you a reset link, or{' '}
                  <a href="mailto:hello@getnave.com">get in touch</a> if you need help.
                </p>
                <form className='form' noValidate onSubmit={this.handleSubmit}>
                  <div className='form_container'>
                    <label>Email</label>
                    <input
                      autoFocus
                      className='form-control'
                      name="email"
                      type="email"
                      id="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                    />
                  </div>
                  <Button variant="primary" type="submit">
                    Send reset link
                  </Button>
                  <Link className='link-back' to={`/login${this.props.location.search}`}>
                    Back
                  </Link>
                </form>
              </div>
            ) : (
              <div className='left_part'>
                <h1>Forgot your password?</h1>
                <p className="mb-4">We’ve sent you an email with instructions to reset your password.</p>

                <Link className='link-back' to={`/login${this.props.location.search}`}>
                  Back to login
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ForgotPage.propTypes = {
  intl: intlShape.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (body) => dispatch(forgotPassword(body)),
    setError: (err) => dispatch(handleError(err)),
  };
};

function mapStateToProps(state) {
  return {
    app: state.app.app,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ForgotPage)));
